import React from 'react';
import { Clock, CheckCircle, XCircle, CheckSquare, AlertCircle, DollarSign, Package, Undo2, Trash2 } from 'lucide-react';

export function getStatusIcon(status: string) {
  const normalized = (status || '').toLowerCase();
  if (normalized === 'tobeverified') return <Clock size={16} style={{ color: '#b45309' }} />;
  if (normalized === 'verified') return <CheckCircle size={16} style={{ color: '#16a34a' }} />;
  if (normalized === 'invalid') return <XCircle size={16} style={{ color: '#b91c1c' }} />;
  if (normalized === 'list') return <CheckSquare size={16} style={{ color: 'rgb(17, 80, 19)' }} />;
  if (normalized === 'delistinprogress' || normalized === 'delistrequested') return <AlertCircle size={16} style={{ color: '#b91c1c' }} />;
  if (normalized === 'delist') return <Package size={16} style={{ color: '#b91c1c' }} />;
  if (normalized === 'sold') return <DollarSign size={16} style={{ color: 'rgb(5, 150,   215)' }} />;
  if (normalized === 'settled') return <CheckCircle size={16} style={{ color: '#10b981' }} />;
  if (normalized === 'settlementinprogress') return <Package size={16} style={{ color: '#6366f1' }} />;
  if (normalized === 'failed') return <XCircle size={16} style={{ color: '#b91c1c' }} />;
  if (normalized === 'unsold') return <XCircle size={16} style={{ color: '#b91c1c' }} />;
    if (normalized === 'return') return <Undo2 size={16} style={{ color: '#b91c1c' }} />;
  if (normalized === 'closed' || normalized === 'listingrequestcancelled') return <XCircle size={16} style={{ color: '#b91c1c' }} />;
    if (normalized === 'deleted') {
    return <Trash2 size={14} />;
  }
  return <AlertCircle size={16} style={{ color: '#64748b' }} />;
}
